import * as yup from 'yup'

const schema = yup.object().shape({
  email: yup.string().email().max(255).required(),
  name: yup.string().max(255),
  observation: yup.string(),
})

export default schema
